<template>
  <div class="patient-list">
    <div class="listWarpper">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div class="searchBox">
            <!-- <div class="mainItem" >
          <el-select v-model="status" placeholder="请选择" @change="optChange">
            <el-option
                    v-for="item in options"
                    :key="item.status"
                    :label="item.label"
                    :value="item.status"
            ></el-option>
          </el-select>
        </div>-->
            <div class="mainItem">
              <el-date-picker v-model="time" type="daterange" align="center" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" @change="optChange"></el-date-picker>
            </div>
            <div class="searchInput mainItem">
              <el-input v-model="name" placeholder="请输入姓名" @keyup.native="nameChange"></el-input>
            </div>
            <div class="searchInput mainItem">
              <el-button class="searchInput_btn" type="primary" @click="search">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <el-table :data="list_data" style="width: 100%" @sort-change="sortChange">
              <el-table-column align="center" label="患者姓名">
                <template slot-scope="scope">
                  <p>姓名: {{ scope.row.name }}</p>
                  <div slot="reference" class="name-wrapper">
                    <!--<el-tag size="medium">{{ scope.row.name }}</el-tag>-->
                    <p>{{ scope.row.name }}({{ scope.row.gender_text }})</p>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="年龄">
                <template slot-scope="scope">
                  <div class="name-wrapper">{{ scope.row.age }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="科室">
                <template slot-scope="scope">
                  <div class="name-wrapper">{{ scope.row.department }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="检查时间">
                <template slot-scope="scope">
                  <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
                  <i class="el-icon-time"></i>
                  <span style="margin-left: 10px">{{ scope.row.created }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <div class="name-wrapper">{{ scope.row.prescription_status_describe }}</div>
                </template>
              </el-table-column>
              <!--<el-table-column label="过敏史" width="300">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="症状" width="300">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" v-show="scope.row.is_eye_department == 1" @click="handleCheck(scope.$index, scope.row)">阅片</el-button>
                  <el-button size="mini" type="danger" @click="handleDetail(scope.$index, scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageWarpper" v-show="list_data != ''">
          <el-pagination @current-change="currentPageChange" :page-size="pageList.pageSize" :current-page="pageList.pageNum"
            layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import util from "@/utils";
import { getSickList, getOrderList } from "@/api/index.js";
export default {
  data() {
    return {
      list_data: [],
      tableData: [],
      pageList: {
        pageSize: 10,
        pageNum: 1
      },
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      options: [
        {
          status: "-1",
          label: "全部"
        },
        {
          status: "0",
          label: "待确认"
        },
        {
          status: "1",
          label: "已确认"
        },
        {
          status: "2",
          label: "已拒绝"
        }
      ],
      status: "-1",
      time: [],
      name: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      value2: ""
    };
  },
  methods: {
    search() {
      console.log("name", name);
      this.pageList.pageNum = 1;
      this.readyPatientList();
    },
    //分页
    currentPageChange(page) {
      this.pageList.pageNum = page;
      this.readyPatientList();
    },
    //阅片
    handleCheck(index, row) {
      let query = {
        sickId: row.sick_id,
        sickImId: row.im_accid,
        casesId: row.cases_id,
        orderId: row.id,
        from: "workDetail",
        tabNum: this.$route.query.tabNum
      };
      if (row.is_hava_report == 1) {
        this.$router.push({
          path: "/index/user/reportManage",
          query: { tabNum: this.$route.query.tabNum }
        });
      } else {
        this.$router.push({
          path: "/index/work/slice",
          query
        });
      }
    },
    //查看详情
    handleDetail(index, row) {
      console.log(index, row);
      if (row.im_accid === "null" || row.im_accid === null) {
        this.$message({
          type: "error",
          message: "该患者已不存在或者被删除"
        });
        return
      }
      let query = {
        tabNum: this.$route.query.tabNum,
        fromType: "workdetail",
        sessionId: "p2p-" + row.im_accid
      };
      if (row.id) {
        this.$router.push({
          path: "/index/work/chart",
          query
        });
      } else {
        this.$message({
          type: "error",
          message: "当前会话已删除"
        });
      }
    },
    sortChange(column, prop, order) {
      console.log("val:", column, prop, order);
    },
    //下拉列表选项改变
    optChange(val) {
      var tabNum = this.$route.query.tabNum;
      if (tabNum == "2") {
        this.readyPatientList();
      } else if (tabNum == "3") {
        this.readyApointList();
      }
    },
    //关键字输入框离开事件
    nameChange() {
      console.log("name: ", this.name);
    },
    /**
     * 初次获取我的患者列表
     */
    readyPatientList() {
      const that = this;
      let params = {
        status: that.status === "-1" ? "" : that.status,
        start_time: that.time.length > 0 ? that.time[0].getTime() : "",
        end_time: that.time.length > 0 ? that.time[1].getTime() : "",
        pageNum: that.pageList.pageNum,
        pageSize: that.pageList.pageSize,
        keyword: that.name
      };
      getSickList(params).then(that.readyHandle);
    },
    readyHandle(res) {
      const that = this;
      const result = res.data;
      if (res.code === 1) {
        that.list_data = result.data;
        that.pageList.pageNum = result.pageNum;
        that.pageList.pageSize = result.pageSize;
        that.pageList.total = result.total; //却分页字段
      } else {
        that.$message({
          showClose: true,
          message: res.msg,
          type: "error"
        });
      }
    },

  },
  mounted() {
    this.readyPatientList();
  }
};
</script>

<style lang="scss" scoped>
.patient-list {
  padding: 20px;

  .mainItem {
    float: left;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
  }

  .mainItem:nth-child(3) {
    width: 20%;
  }
  .pageWarpper {
    text-align: center;
  }
  .searchInput_btn {
    margin-left: 80px;
    height: 40px;
    width: 100px;
  }
}
</style>
